import React from 'react';
import { Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
import LinearProgressBar from '../../../../../../Generic/Progress/LinearProgressBar';

const Root = styled(Grid)(({ theme }) => ({}));

const IndexIndicatorsContainer = styled(Grid)(({ theme }) => ({
	width: '100%',
	marginTop: '15px',
	display: 'flex',
	gap: '15px'
}));

function StackIndex({ index }) {
	return (
		<Root>
			<IndexIndicatorsContainer>
				{[...Array(3).keys()].map((i) => (
					<LinearProgressBar key={i} animate={i !== 0} value={i <= index ? 100 : 0} />
				))}
			</IndexIndicatorsContainer>
		</Root>
	);
}

export default StackIndex;
